import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class DirtRoadTileEntity4 extends TileEntity {
	public static readonly frameName = FrameName.DIRT_ROAD_4;
}

export default DirtRoadTileEntity4;
